import React, { useEffect, useState, useRef, FC } from 'react';
import * as eCharts from 'echarts';
import { mathFormat } from '@/pages/intelligence/utils/commonUtils';
import { lineTooltipFormatter } from '../Retention/linechart';
import { useIntl, getLocale } from 'umi';
import { TimePeriodType } from '../../types';

interface TrendsBarChartProps {
  segment: string;
  barData: any[];
  timePeriod: TimePeriodType;
}

const TrendsBarChart: FC<TrendsBarChartProps> = (props) => {
  let myChart: any = null;
  const chartRef = useRef(null);
  const [options, setOptions] = useState<any>();
  const { segment, barData = [], timePeriod } = props;
  const { formatMessage } = useIntl();
  const locale = getLocale();
  // const [activeSegment, setActiveSegment] = useState('ltv365');

  useEffect(() => {
    const xAxisList = barData?.map((item, index) => {
      return timePeriod === '1y~5y'
        ? `${formatMessage({ id: 'dbi_benchmark_year' }, { num: index + 1 })}`
        : `M${index + 1}`;
    });
    const regionOptions = {
      tooltip: {
        backgroundColor: 'rgba(255, 255, 255, 0)',
        extraCssText: 'border: none;',
        padding: 0,
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
          label: {
            show: true,
            color: '#3B3D4B',
            backgroundColor: '#FFF',
          },
        },
        formatter: (param: any[]) => {
          return lineTooltipFormatter(
            param?.sort((a, b) => b?.value - a?.value),
            param[0]?.axisValue,
            '',
            (value: any) => `${mathFormat(value, true)}`,
          );
        },
        appendToBody: true,
      },
      legend: {
        show: true,
        icon: 'circle',
        type: 'scroll',
        selectedMode: true,
        textStyle: {
          fontSize: 12,
          color: '#888',
        },
        pageIconSize: 10,
        pageTextStyle: {
          color: '#707070',
        },
        itemWidth: 8,
        itemHeight: 8,
        itemGap: 20,
        bottom: -4,
      },
      grid: {
        left: 2,
        right: '0',
        bottom: '30px',
        top: 20,
        containLabel: true,
      },
      xAxis: {
        type: 'category',
        data: xAxisList,
        axisTick: {
          alignWithLabel: true,
        },
        axisLabel: {
          margin: 10,
          interval: 0,
          showMaxLabel: true,
          showMinLabel: true,
          color: '#000',
          opacity: 0.45,
        },
        axisLine: {
          show: true,
          onZero: false,
          lineStyle: {
            color: '#BFBFBF',
            width: 1,
          },
        },
      },
      yAxis: [
        {
          type: 'value',
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
            },
          },
          splitNumber: 3,
          axisLabel: {
            color: '#000',
            opacity: 0.45,
            formatter: (value, index) => `${mathFormat(value, true)}`,
          },
        },
        {
          type: 'value',
          splitLine: {
            show: false,
          },
          axisLabel: {},
          splitNumber: 3,
        },
      ],
      color: ['#5086F3', '#5EC8F1'],
      series: [
        {
          name: `${formatMessage({ id: 'dbi_mobile' })}${locale === 'zh-CN'? '': ' '}${formatMessage({
            id: `dbi_benchmark_${segment}_mobile`,
          })}`,
          type: 'bar',
          data: barData,
          barCategoryGap: '50%',
          z: 3,
        },
      ],
    };
    setOptions(regionOptions);
  }, [segment, locale, barData]);

  useEffect(() => {
    if (myChart === null) {
      myChart = eCharts.init(chartRef!.current!);
    }
    options && myChart.setOption(options, true);
  }, [options]);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [myChart]);

  const handleResize = () => {
    try {
      myChart.resize();
    } catch (err) {}
  };
  return <div style={{ height: 252, width: '100%' }} ref={chartRef}></div>;
};

export default TrendsBarChart;
